import type { assurances as Fr } from '../fr/assurances';

/** « assurances » in English — typed on the French: a missing sentence does not compile. */
export const assurances: typeof Fr = {
  couverture: { tous_risques: 'Comprehensive', tiers_plus: 'Third party plus', tiers: 'Third party' },
  policeMaj: 'Policy updated.',
  policeEnregistree: 'Policy saved — the menu alert now follows the new expiry date.',
  enregistrementImpossible: 'Unable to save',
  titre: 'Insurance',
  sousTitre: 'One policy per vehicle · the excess decides what you actually recover',
  enregistrerPolice: 'Add a policy',
  sansPolice: (n: number) => `${n} ${n === 1 ? 'vehicle' : 'vehicles'} without a recorded policy`,
  sansPoliceTexte: '— in an accident, nobody will know whom to call or which excess applies.',
  aucune: 'No policies recorded',
  premiere: 'Add the first one',
  videTexte: 'Record the insurer, policy number and excess for each vehicle. The expiry date drives the menu alert, and the excess is used to work out a claim.',
  expireeDepuisCourt: (j: number) => `Expired ${j} d ago`,
  joursCourt: (j: number) => `${j} d`,
  police: (n: string, d: string) => `Policy ${n} · until ${d}`,
  franchiseDe: (m: string) => `Excess ${m}`,
  col: {
    vehicule: 'Vehicle', assureur: 'Insurer', numero: 'Policy no.', couverture: 'Cover',
    fin: 'Cover ends', prime: 'Premium', franchise: 'Excess',
  },
  expireeDepuis: (j: number) => `expired ${j} ${j === 1 ? 'day' : 'days'} ago`,
  dans: (j: number) => `in ${j} ${j === 1 ? 'day' : 'days'}`,
  renouveler: 'Renew',
  note: 'Renewing a policy archives the previous one and updates the vehicle’s expiry date: the menu alert follows on its own.',
  modifierPolice: 'Edit policy',
  policeAssurance: 'Insurance policy',
  vehicule: 'Vehicle',
  choisir: '— choose —',
  assureur: 'Insurer',
  assureurExemple: 'SAA, CAAR, CAAT…',
  agence: 'Branch',
  facultatif: 'Optional.',
  numero: 'Policy no.',
  couvertureLabel: 'Cover',
  debut: 'Cover starts',
  fin: 'Cover ends',
  finAide: 'This is the date that triggers the alert.',
  prime: (d: string) => `Annual premium (${d})`,
  franchise: (d: string) => `Excess (${d})`,
  franchiseAide: 'What you still pay on each claim.',
  telephone: 'Insurer’s phone',
  telephoneAide: 'To call on the day of an accident.',
  annuler: 'Cancel',
  enregistrer: 'Save',
};
